module.exports = __webpack_public_path__ + "static/media/ITC-OfficinaSansITCPro-Book.0c92b84a.eot";